import { Collapse } from 'antd'
import styled from 'styled-components'

export const AlertTabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const AlertTabConfigContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0px 3px 20px 3px;
  justify-content: center;
  flex-direction: column;
`
export const AlertConfigureCollapse = styled(Collapse)`
  width: 100%;
  & .ant-collapse-item > .ant-collapse-header {
    align-items: center;
  }
`
export const AlertConfigureCollapseTitle = styled.div`
  font-weight: 500;
  margin-bottom: 0px;
  font-size: 1.1em;
`

export const AlertTabHeader = styled.div`
  margin: 10px 3px;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  & button.action {
    border: none;
    padding: 0px;
    margin: 4px 10px;
    padding: 0px;
    background: transparent;
  }
  & .alertColorTagContainer {
    display: flex;
    align-items: center;
    flex: 1 1 0;
    justify-content: center;
    gap: 15px;
  }
  & .alertColorTag {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  & .alertConfigUpdateContainer {
    display: flex;
    align-items: center;
    width: 90%;
    justify-content: flex-start;
    gap: 15px;
  }
  & .iconButton {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .anticon {
      margin-left: 0px;
    }
  }
  & .closeAlertConfigUpdateContainer {
    width: 150px;
    display: flex;
    justify-content: flex-end;
  }
  & .closeAlertConfigUpdateContainer > button.close {
    border: none;
    padding: 0px;
    margin: 0px;
    width: 20px;
    background: transparent;
  }
`

export const ConfigureAlertContainer = styled.div`
  padding: 20px 0px;
`
